// axios
import axios from 'axios';
// routes
import {routes} from "../../../features/routes/route";
// config
import {MoghavematConfig} from "../../../config/moghavematConfig";

export const paymentEzdevaj = async (data: any) => {
    const {data: response} = await axios.post(`${routes.api[2].address}Payment/EzdevajTransAction`, data, MoghavematConfig);
    return response;
};
